// extracted by mini-css-extract-plugin
export default {"followUserButton":"pfNb917ShXet0wJabgt7"};